import router from "../router/router.js";

export const requestMiddleware = (res) => {
  if (res.is_banned || res.is_suspended) {
    alert(`Your account is ${res.message}`);
    router.push("/logout/");
  }
};
